<template>
  <div class="md:flex md:gap-16">
    <RevCard class="mb-16 flex-1 p-24 md:mb-0">
      <h2 class="heading-2 mb-8">
        {{ i18n(translations.mainContactTitle) }}
      </h2>
      <div class="text-action-default-low body-1 mb-20">
        {{ i18n(translations.mainContactDescription) }}
      </div>
      <div class="mb-8 flex items-center">
        <IconMail class="mr-8" />
        <span class="text-action-default-hi body-1">{{ email }}</span>
      </div>
      <span class="text-action-default-low caption">
        {{ i18n(translations.mainContactInfo) }}
      </span>
    </RevCard>
    <CommunicationLanguage v-if="!hasOnlyOneMarket" class="flex-1" />
  </div>

  <Mailbook v-if="isMailbookRevampEnabled" />

  <AdditionalContacts v-else />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { IconMail } from '@ds/icons/IconMail'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import translations from './ContactDetails.translations'
import AdditionalContacts from './components/AdditionalContacts/AdditionalContacts.vue'
import CommunicationLanguage from './components/CommunicationLanguage/CommunicationLanguage.vue'
import Mailbook from './components/Mailbook/Mailbook.vue'

const i18n = useI18n()
const { email, hasOnlyOneMarket } = useSellerInfoStore()
const { isFeatureEnabled } = useBusinessFeaturesStore()

const isMailbookRevampEnabled = isFeatureEnabled('isRevampedMailbookEnabled')
</script>
